import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { AuthService } from '../../services/auth.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule
],
  templateUrl: './login.html',
  styleUrls: ['./login.scss']
})
export class LoginComponent {
  username: string = '';
  password: string = '';
  hidePassword: boolean = true;
  errorMessage: string = '';
  environmentName: string = environment.appName;

  constructor(
    private router: Router, 
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    // Debug: localStorage tartalmának kiírása - csak böngészőben
    // console.log('Login komponens betöltődött');
    if (isPlatformBrowser(this.platformId)) {
      // console.log('localStorage token:', localStorage.getItem('token')?.substring(0, 50));
      // console.log('localStorage userData:', localStorage.getItem('userData'));
    }
  }

  onLogin() {
    this.errorMessage = ''; // Clear previous error
    
    // Minden bejelentkezés előtt töröljük a localStorage-t - csak böngészőben
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('token');
      localStorage.removeItem('userData');
    }
    
    this.authService.login(this.username, this.password).subscribe({
      next: (result) => {
        if (!result.success) {
          this.errorMessage = result.message || 'Hibás felhasználónév vagy jelszó!';
        }
        // Ha sikeres, a router navigation az AuthService-ben történik
      },
      error: (err) => {
        this.errorMessage = 'Hálózati hiba történt!';
      }
    });
  }
}
